import { NotizArtenResponse } from '@/types/service-response'

export class ProductNoteType {
  public constructor (
    readonly id: number,
    readonly name: string
  ) {}

  static createFromResponse (responseData: NotizArtenResponse[]): Array<ProductNoteType> {
    let result: Array<ProductNoteType> = []
    if (responseData) {
      result = responseData.map((item: NotizArtenResponse ) => {
        return new ProductNoteType(
          item.ID,
          item.Bezeichnung ? item.Bezeichnung : ''
        )
      })
    }
    return result
  }
}
